(ns practitest.frontend.tests.test-form
  (:require
    [clojure.data]
    [clojure.set]
    [clojure.string :as str]
    [clojure.tools.reader :refer [read-string]]
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.i18n :refer [get-translation format-translation]]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.re-frame :refer [partial-dispatch]]
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components2.test-type :as test-type]
    [practitest.frontend.components2.traceability :as traceability]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
    [practitest.frontend.forms3.entity-form.fields :as fields]
    [practitest.frontend.forms3.entity-form.forms :as f3.forms]
    [practitest.frontend.forms3.entity-form.utils :refer [track!]]
    [practitest.frontend.kanban :as kanban]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.similar-items :as similar-items]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.tests.events :as tests-events]
    [practitest.frontend.tests.test-form.common :refer [steps-form-id
                                                        test-form-id]]
    [practitest.frontend.tests.test-form.test-steps :as test-form.test-steps]
    [practitest.frontend.tests.test-versioning :as test-versioning]
    [practitest.frontend.tests.test-versioning-management-tab :as versioning-management]
    [practitest.frontend.tests.version-label-common :as versioning-common]
    [re-frame.core :as re-frame]))

(def ^:private current-form-id test-form-id)
(def ^:private current-entity-type :test)
(def ^:private params-entity-key :qtest_design)

(def metadata (get metadata/entities-metadata current-entity-type))

(def edit-permission (:edit-permissions metadata))
(def delete-permission (:delete-permissions metadata))

(defn convert-test-type-menu-item
  [convert-test-type-uri current-type new-type upcase-type]
  (when (and (not= current-type upcase-type)
             (#{"ScriptedTest" "ApiTest" "xBotTest" "FirecrackerTest"} current-type))
    {:text     (get-translation (str "test.button.convert_test_type." new-type) (str "Convert test to " upcase-type " test"))
     :test-id  (str "tests-form-menu-convert-test-type-to-" new-type)
     :on-click (fn [e]
                 (dom/prevent-default e)
                 (track! "Convert test type" current-entity-type)
                 (dom/form-navigate! convert-test-type-uri {"_method" "put" "type_to" new-type}))
     :icon     [(:icon (get test-type/types-map upcase-type))]}))

(defn show-hide-steps-tab []
  (let [steps-tab-hidden? @(re-frame/subscribe [::steps-tab-hidden? current-form-id])
        test (:current @(re-frame/subscribe [::subs/entity current-entity-type]))
        test-id (:id test)]
    {:text     (if steps-tab-hidden?
                 (get-translation "test.button.show_steps_tab" "Show Steps tab")
                 (get-translation "test.button.hide_steps_tab" "Hide Steps tab"))
     :test-id  (if steps-tab-hidden?
                 "test-form-menu-show-steps"
                 "test-form-menu-hide-steps")
     :on-click (fn [e]
                 (dom/prevent-default e)
                 (re-frame/dispatch [::set-hide-steps-tab current-form-id test-id (not steps-tab-hidden?)]))
     :mixpanel (if steps-tab-hidden?
                 ["Form Actions" {"Entity" "Test" "Action" "Show steps in Test"}]
                 ["Form Actions" {"Entity" "Test" "Action" "Hide steps in Test"}])
     :icon     (if steps-tab-hidden?
                 [icons/mux-eye]
                 [icons/mux-eye-off])}))

(defn show-steps-tab? []
  (let [form-state @(re-frame/subscribe [::f3.forms/form-state current-form-id])
        test-type (get-in form-state [:fields :test_type :value])]
    (not (#{"xBotTest" "BDDTest" "ExploratoryTest"} test-type))))

(defn show-automation-tab? []
  (let [test (:current @(re-frame/subscribe [::subs/entity current-entity-type]))
        form-state @(re-frame/subscribe [::f3.forms/form-state current-form-id])
        test-type (or (:test_type test)
                      (get-in form-state [:fields :test_type :value]))]
    (when test-type
      (not (#{"ScriptedTest" "BDDTest" "ExploratoryTest"} test-type)))))

(defn test-menu []
  (let [test (:current @(re-frame/subscribe [::subs/entity current-entity-type]))
        snapshot? (and test (false? (:current test)))
        current-test-type (:test_type test)
        {:keys [urls]} metadata
        test-id (:id test)
        path-params {:id test-id}
        clone-test-uri (broutes/get-url-view (:clone urls) path-params)
        print-test-uri (broutes/get-url-view (:print urls) path-params {"ids" test-id})
        convert-test-type-uri (broutes/get-url-view (:convert-test-type urls) path-params)
        delete-permission? (permissions/has-permission? delete-permission)

        enabled-automation-types @(re-frame/subscribe [::subs/enabled-automation-types])

        print-menu-item {:text        (get-translation "generic.button.print" "Print")
                         :test-id     "test-form-menu-print"
                         :icon        [icons/mux-printer]
                         :mixpanel    ["Form Actions" {"Entity" "Test" "Action" "Print entity"}]
                         :new-window? true
                         :href        print-test-uri}]
    (if snapshot?
      [print-menu-item]
      [print-menu-item

     {:text     (get-translation "generic.button.clone" "Clone")
      :test-id  "test-form-menu-clone"
      :on-click (fn [e]
                  (dom/prevent-default e)
                  (track! "Clone entity" current-entity-type)
                  (dom/form-navigate! clone-test-uri {"_method" "post"}))
      :icon     [icons/mux-clone]}

     {:text     (get-translation "generic.button.delete" "Delete")
      :test-id  "test-form-menu-delete"
      :disabled? (not delete-permission?)
      :on-click (fn [e]
                  (when delete-permission?
                    (dom/prevent-default e)
                    (when (js/confirm (get-translation "entity.confirm.action-delete" "Are you sure? This Operation cannot be undone."))
                      (track! "Delete entity" current-entity-type)
                      (re-frame/dispatch [::common-events/delete-current-entity current-form-id]))))
      :icon     [icons/mux-trash]}

     (convert-test-type-menu-item convert-test-type-uri current-test-type "scripted" "ScriptedTest")
     (when (contains? enabled-automation-types "api")
       (convert-test-type-menu-item convert-test-type-uri current-test-type "api" "ApiTest"))
     (when (contains? enabled-automation-types "xbot")
       (convert-test-type-menu-item convert-test-type-uri current-test-type "xbot" "xBotTest"))
     (when (contains? enabled-automation-types "firecracker")
       (convert-test-type-menu-item convert-test-type-uri current-test-type "firecracker" "FirecrackerTest"))

     (when (show-steps-tab?)
       (show-hide-steps-tab))])))

(defn- form-layout-test
  [form-id new? entity-fields test]
  (let [snapshot? (and test (false? (:current test)))
        kanban-enabled? @(re-frame/subscribe [::subs/kanban-enabled?])
        edit? (not new?)
        nil-or-unavailable? (fn [field]
                              (or (nil? field)
                                  (not (contains? entity-fields field))))
        initial-layout {:title {:fields [{:field :name}]}
                        :automation {:fields [{:field :automated_test_design}
                                              {:field :script_repository}]}}
        existing-fields (set (f3.forms/flatten-layout initial-layout))
        test-type-specific-fields-to-remove #{:description :test_type :charter :guide_points :scenario :preconditions}
        to-remove? (fn [field]
                     (or (nil-or-unavailable? field)
                         (contains? existing-fields field)
                         (contains? test-type-specific-fields-to-remove field)
                         (test-type/automated-test-fields field)))

        form-state @(re-frame/subscribe [::f3.forms/form-state form-id])
        ;; A bit of a chicken and egg problem - in order to render form layout
        ;; we need to know which test type is selected currently
        ;; entity type wins on edit form, form-state on new form, default before anything's loaded
        selected-test-type (or (:test_type test)
                               (get-in form-state [:fields :test_type :value])
                               metadata/default-test-type)
        automation-layout-fields (case selected-test-type
                                   "ApiTest" []
                                   "FirecrackerTest" []
                                   "xBotTest" [:script_path :client_id :results_path :num_of_results]
                                   ;; else
                                   [])

        layout (if snapshot?
                 (-> initial-layout
                     (f3.entity-form/update-layout (:description f3.entity-form/sections-keys) [:description] :top-left entity-fields)
                     (f3.entity-form/update-layout :automation automation-layout-fields :automation entity-fields)
                     (f3.entity-form/update-layout (:test-versioning f3.entity-form/sections-keys) [] "test_versioning" entity-fields)
                     )

                 (let [filtered-entity-fields (cond-> (f3.entity-form/filter-entity-fields entity-fields to-remove?)
                                                kanban-enabled? (assoc :kanban_lane kanban/kanban-field))
                       filtered-entity-fields-flat (vec (keys filtered-entity-fields))
                       entity-sections @(re-frame/subscribe [::subs/entity-sections current-entity-type])
                       preconditions-enabled? (contains? entity-fields :preconditions)
                       exploratory-fields (if preconditions-enabled?
                                            [:charter :preconditions :guide_points]
                                            [:charter :guide_points])
                       top-left-layout-fields (case selected-test-type
                                                ("ScriptedTest" "ApiTest" "FirecrackerTest" "xBotTest") [:description]
                                                "BDDTest" [:description :scenario]
                                                "ExploratoryTest" exploratory-fields
                                                ;; else - should not happen in normal conditions
                                                [])
                       test-type-pos (if edit? (:general-info f3.entity-form/sections-keys) :title)
                       test-type-system-section (if edit? "general_info" :title)
                       update-main-sections (if (some? entity-sections)
                                              #(f3.entity-form/update-layout % entity-sections filtered-entity-fields)
                                              #(f3.entity-form/update-layout % (:general-info f3.entity-form/sections-keys) filtered-entity-fields-flat "general_info" entity-fields))]
                   (-> initial-layout
                       (f3.entity-form/update-layout test-type-pos [:test_type] test-type-system-section entity-fields)
                       (update-main-sections)
                       (f3.entity-form/update-layout (:description f3.entity-form/sections-keys) top-left-layout-fields :top-left entity-fields)
                       (f3.entity-form/update-layout :automation automation-layout-fields :automation entity-fields)
                       (f3.entity-form/update-layout (:test-versioning f3.entity-form/sections-keys) [] "test_versioning" entity-fields))))]
    layout))

(defmethod f3.forms/build-entity-form-layout current-form-id
  [form-id new? _ entity-fields entity]
  (form-layout-test form-id new? entity-fields entity))

;; Generic + Steps for now
(defn automation-panel [{:keys [new?] :as form-props}]
  (fn [{:keys [layout] :as form-props}]
    (let [section-fields (get-in layout [:automation :fields])
          automation-fields #{:automated_test_design :script_repository}
          {automation-fields true specific-xbot-fields false} (group-by #(contains? automation-fields (:field %)) section-fields)]
      [:section.automation-panel
       (when new?
         [fields/test-type-field-radio-btns {:field-name        :test_type
                                             :edit-permissions? true}
          form-props])
       [f3.entity-form/fields-view form-props automation-fields]

       (when (seq specific-xbot-fields)
         [:div.xbot-fields-section
          [:div.xbot-title-section
           [:div.xbot-section-label
            [:label.xbot-label (get-translation "test.xbot.label.xbot_information"
                                                "xBot Information")]]]

          [:div.xbot-fields
           [f3.entity-form/fields-view form-props specific-xbot-fields]]])])))

(defn automation-card
  [{:keys [form-ref] :as form-props}]
  [:div.entity-grid
   {:ref #(reset! form-ref %)}
   [automation-panel form-props]])

(defn automation-tab []
  {:tab-id :automation
   :tab-title (get-translation "entity.tab.automation" "Automation")
   :tab-view automation-card})

(defn build-test-tabs
  [edit?]
  (let [project-settings @(re-frame/subscribe [::subs/current-project])
        test (:current @(re-frame/subscribe [::subs/entity current-entity-type]))
        snapshot? (and test (false? (:current test)))
        test-type (:test_type test)
        is-bdd-test? (= test-type "BDDTest")
        enforce-test-traceability? (:enforce_test_traceability project-settings)
        traceability-tab (traceability/build-traceability-tab)
        traceability @(re-frame/subscribe [::traceability/traceability])
        total-count (traceability/traceability-total-count traceability)
        traceability-tab-with-required (if enforce-test-traceability?
                                         (update traceability-tab :tab-title
                                                 (fn [_]
                                                   [:span.text-nowrap
                                                    (format-translation
                                                      (get-translation "entity.tab.traceability" "Traceability (%{n})")
                                                      :n total-count)
                                                    [:span.mandatory {:style {:font-size "1rem"}} "*"]]))
                                         traceability-tab)
        test-case-versioning-enabled? @(re-frame/subscribe [::subs/test-case-versioning-enabled?])]
    [(f3.entity-form/general-entity-tab)

     (let [steps-tab-hidden? @(re-frame/subscribe [::steps-tab-hidden? current-form-id])
           steps (get @(re-frame/subscribe [::subs/entity current-entity-type]) :steps)
           steps-count (count steps)]
       (when (and (show-steps-tab?)
                  (not steps-tab-hidden?))
         {:tab-id :steps
          :tab-title [:span.text-nowrap
                      (format-translation
                        (get-translation "test.tab.steps" "Steps (%{n})")
                        :n (or steps-count 0))]
          :tab-view test-form.test-steps/steps-tab}))

     (when (not snapshot?)
       traceability-tab-with-required)

     (when (and edit? (not snapshot?))
       (f3.entity-form/history-tab))

     (when (and edit? test-case-versioning-enabled? (not snapshot?) (not is-bdd-test?))
       (versioning-management/build-version-labels-tab))

     (when (show-automation-tab?)
       (automation-tab))]))

(def new-controller
  {:start (fn [params]
            (re-frame/dispatch [::f3.forms/reset-form-state current-form-id true current-entity-type])
            (re-frame/dispatch [::test-form.test-steps/reset-form-state])
            (re-frame/dispatch [::set-hide-steps-tab current-form-id nil false])
            (re-frame/dispatch [::events/set-current-entity-type current-entity-type])
            (re-frame/dispatch [::similar-items/clear-similar-items])
            (re-frame/dispatch [::events/set-new-entity-traceability current-entity-type])
            (re-frame/dispatch [::tests-events/fetch-steps-params])
            (re-frame/dispatch [::similar-items/similar-items-expand :test :test-main])
            (let [project-id (get-in params [:path :project-id])]
              (re-frame/dispatch [::f3.entity-form/fetch-fields {:form-id     current-form-id
                                                                 :entity-type current-entity-type
                                                                 :project-id  project-id
                                                                 :new?        true}]))
            (let [query (:query params)
                  generate-steps? (read-string (:generate_steps query))]
              ;; create test from jira panel with/out requirement
              ;; or from requirement traceability tab
              (when-let [requirement-id (:requirement_id query)]
                (re-frame/dispatch [::tests-events/link-requirement requirement-id generate-steps?]))

              ;; create test from ET
              (when-let [et-id (:et_id query)]
                (re-frame/dispatch [::tests-events/fetch-et-details et-id]))))

   :identity :parameters})

(def edit-controller
  {:start    (fn [params]
               (let [{:keys [test-id project-id]} (:path params)]
                 (re-frame/dispatch [::f3.forms/reset-form-state current-form-id false current-entity-type])
                 (re-frame/dispatch [::events/set-current-entity-type current-entity-type])
                 (re-frame/dispatch [::subs/set-current-entity-id
                                     current-entity-type
                                     test-id])
                 (let [fetch-options {:form-id current-form-id
                                      :entity-type current-entity-type
                                      :entity-id test-id
                                      :project-id project-id
                                      :new? false
                                      :got-entity-data [[::got-test-entity]
                                                        [::similar-items/similar-items-expand :test :test-main]]}]
                   (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                   (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])
                   (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]]))
                 (re-frame/dispatch [::events/fetch-comments])
                 (re-frame/dispatch [::events/fetch-attachments])
                 (re-frame/dispatch [::events/fetch-history])
                 (re-frame/dispatch [::versioning-common/fetch-version-labels project-id test-id])
                 (re-frame/dispatch [::restore-hidden-steps-tab current-form-id test-id])
                 (re-frame/dispatch [::common-events/trigger-online-request])
                 (re-frame/dispatch [::common-events/reset-expanded current-entity-type (:test subs/index-grid-keys)])
                 (mixpanel/track "Grid Actions" {"Action" "Edit Test"})))
   :stop     (fn [_params]
               (re-frame/dispatch [::events/clear-current-entity current-entity-type])
               (re-frame/dispatch [::test-form.test-steps/reset-form-state])
               (re-frame/dispatch [::similar-items/clear-similar-items])
               (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
               (re-frame/dispatch [::common-events/reset-expanded :test [:test-steps :history2]])
               (re-frame/dispatch [::f3.forms/reset-form-state current-form-id false current-entity-type]))
   :identity :parameters})

;; Special glue code to integrate entity form and test steps tab
(re-frame/reg-sub
  ::dirty-fields-override
  (fn []
    [(re-frame/subscribe [::f3.forms/dirty-fields current-form-id])
     (re-frame/subscribe [::f3.forms/form-state steps-form-id])])
  (fn [[main-dirty-fields steps-form-state]]
    ;; Steps section is dirty if any field in steps editor is dirty or if precondition field has been changed
    (let [steps-dirty (seq (filter :dirty?
                                   (concat (vals (:fields steps-form-state))
                                           ;; steps nested fields
                                           (mapcat
                                             #(vals (:fields %))
                                             (vals (:steps steps-form-state))))))
          ;; Or if form is marked as dirty (e.g. ordering has changed)
          form-dirty? (:dirty? steps-form-state)]
      (concat main-dirty-fields
              (if (or steps-dirty form-dirty?)
                ;; We treat any step changes as "1 property" change for now
                [{:id :steps}]
                [])))))

(re-frame/reg-event-db
  ::reset-test-form
  (fn [db [_ new?]]
    ;; we're in compound form so we need to reset everything - both entity form in General tab
    ;; and steps tab as well (with multiple sub-forms)
    (-> db
        (f3.forms/reset-form-state current-form-id new? current-entity-type)
        (test-form.test-steps/init-steps-form-state
          (get-in db [:entity current-entity-type :current])
          (get-in db [:entity current-entity-type :steps])
          nil))))

(re-frame/reg-event-db
  ::got-test-entity
  (fn [db [_ fetch-options response]]
    (-> db
        (assoc-in [:entity :test :steps] (:steps response))
        (test-form.test-steps/init-steps-form-state
          (get-in db [:entity current-entity-type :current])
          (:steps response)
          nil))))

(re-frame/reg-sub
  ::steps-tab-hidden?
  (fn [[_ form-id]]
    (re-frame/subscribe [::f3.forms/form-state form-id]))
  (fn [form-state _]
    (:steps-tab-hidden? form-state)))

(defn last-state-hide-steps-tab-key [form-id entity-id]
  (when-not (str/blank? entity-id)
    (str form-id ":last-state-hide-steps-tab-key:" entity-id)))

(re-frame/reg-event-db
  ::set-hide-steps-tab
  (fn [db [_ form-id entity-id hide?]]
    (when-let [k (last-state-hide-steps-tab-key form-id entity-id)]
      (.setItem js/sessionStorage k hide?))
    (assoc-in db [:form-states2 form-id :steps-tab-hidden?] hide?)))

(re-frame/reg-event-fx
  ::restore-hidden-steps-tab
  (fn [{:keys [db]} [_ form-id entity-id]]
    (let [hidden-steps-tab
          (some->> (last-state-hide-steps-tab-key form-id entity-id)
                   (.getItem js/sessionStorage))]
      (when hidden-steps-tab
        (let [hidden-steps-tab (= hidden-steps-tab "true")]
          {:fx [[:dispatch [::set-hide-steps-tab form-id entity-id hidden-steps-tab]]]})))))

(defn get-add-to-suite-param []
  (let [params (js/URLSearchParams. (.-search js/window.location))]
    (when (.has params "add_to_suite")
      (.get params "add_to_suite"))))

(defn- handle-exploratory-preconditions
  "Handle preconditions for Exploratory tests by updating form states and params"
  [db current-form-id test-type preconditions params]
  (if-not (and (= test-type "ExploratoryTest") preconditions)
    {:db db :params params}
    (let [;; Update form states
          updated-db (-> db
                         (assoc-in [:form-states2 current-form-id :fields :preconditions :dirty?] true)
                         (assoc-in [:form-states2 steps-form-id :fields :preconditions :value] preconditions))

          updated-params (assoc-in params [:qtest_design :preconditions] preconditions)]
      {:db updated-db :params updated-params})))

(re-frame/reg-event-fx
  ::custom-save-entity
  (fn [{db :db} [_ current-form-id params-entity-key {:keys [new?] :as options}]]
    (let [enforce-test-traceability? (get-in db [:current-project :enforce_test_traceability])
          traceability-data (get-in db [:entity current-entity-type :traceability])
          linked-requirements (get traceability-data :requirements)
          traceability-validation-error? (and enforce-test-traceability?
                                              (or (nil? linked-requirements) (empty? linked-requirements)))

          current-test (get-in db [:entity :test :current])
          current-labels (:version_label current-test)
          test-type (:test_type current-test)
          has-labels? (and (not new?) (seq current-labels))

          main-form-state (get-in db [:form-states2 current-form-id])
          steps-form-state (get-in db [:form-states2 steps-form-id])
          versionable-content-changed? (test-versioning/versionable-content-changed?
                                         main-form-state
                                         steps-form-state
                                         test-type)

          hide-warning? (grid-storage/load-hide-label-reset-warning)
          should-show-warning? (and has-labels?
                                   versionable-content-changed?
                                   (not hide-warning?))

          save-event [::common-events/save-entity
                      current-form-id
                      params-entity-key
                      (assoc options
                             :additional-params-helper
                             (fn [db params]
                               (let [form-state (get-in db [:form-states2 current-form-id])
                                     test-type (get-in form-state [:fields :test_type :value])
                                     preconditions (get-in form-state [:fields :preconditions :value])
                                     is-exploratory-with-preconditions? (and (= test-type "ExploratoryTest") preconditions)

                                    ;; Handle preconditions for Exploratory tests only when needed
                                     {:keys [db params]} (if is-exploratory-with-preconditions?
                                                           (handle-exploratory-preconditions
                                                             db current-form-id test-type preconditions params)
                                                           {:db db :params params})

                                     smartfox-used? (get-in db [:form-states2 steps-form-id :smartfox-used?])
                                     ai-text-enhancement-used? (or (get-in db [:form-states2 steps-form-id :ai-text-enhancement-used?])
                                                                    (get-in db [:form-states2 current-form-id :ai-text-enhancement-used?]))

                                    ;; Merge steps form data
                                     merged (test-form.test-steps/merge-into-steps new? db params)

                                     add-to-suite (get-add-to-suite-param)]
                                 (cond-> merged
                                   add-to-suite (assoc :add_to_suite add-to-suite)
                                   smartfox-used? (assoc :smartfox_used true)
                                   ai-text-enhancement-used? (assoc :ai_text_enhancement_used true)
                                   is-exploratory-with-preconditions? (assoc-in [:qtest_design :preconditions] preconditions))))
                             :got-entity-data [::got-test-entity])]]
      (cond
        traceability-validation-error?
        (do
          (when-let [tab-element (js/document.querySelector "[data-tabid=\"traceability\"]")]
            (.click tab-element))
          ;; Show error notification
          {:dispatch [::notifications/error2
                      (get-translation "test.notify.error-traceability-required"
                                       "At least one requirement must be linked to this test")
                      {:id "api-error-message"}]})

        should-show-warning?
        {:dispatch [::test-versioning/show-label-reset-warning save-event]}

        :else
        {:dispatch save-event}))))

(re-frame/reg-sub
  ::edit-locked
  (fn [db [_]]
    (get-in db [:form-states2 :test-main :base-entity :edit_locked])))

(defn snapshot-warning-banner []
  (let [test (:current @(re-frame/subscribe [::subs/entity current-entity-type]))
        version-labels (:version_label test)
        labels-text (str/join ", " (map :name version-labels))
        updated-at (:updated_at test)
        author-name (:author_user_name test)]
    [:div.alert.alert-warning.m-3.snapshot-warning-banner
     [icons/mux-ancestor-has-changes]
     [:span
      (format-translation
        (get-translation "test.versioning.snapshot.warning"
                         "This is an older version of this test ( Version Label = %{label} saved on %{date} by %{author} ).")
        {:label labels-text
         :date (fu/formatted-date-time (js/Date. updated-at))
         :author author-name})]]))

(defn main [new?]
  (let [test (:current @(re-frame/subscribe [::subs/entity current-entity-type]))
        test-type (:test_type test)
        snapshot? (and test (false? (:current test)))]
    [f3.entity-form/entity-form
     {:new?                       new?
      :popup-menu                 (test-menu)
    :on-save                    (partial-dispatch [::custom-save-entity current-form-id params-entity-key])
    :on-cancel                  (partial-dispatch [::reset-test-form new?])
    :entity-type                current-entity-type
    :form-id                    current-form-id
    :value-score?               (and (= "ScriptedTest" test-type)
                                     (:value-score-enabled? @(re-frame/subscribe [::subs/options])))
    :breadcrumbs                [{:href  (broutes/get-url-view (get-in metadata [:urls :index]) {:project-id (:id @(re-frame/subscribe [::subs/current-project]))})
                                  :label (get-translation "navigation.project-menu.test-library" "Test Library")}]
    :dirty-fields               (re-frame/subscribe [::dirty-fields-override])
    :header-tabs                (build-test-tabs (not new?))
    :edit-permissions?          (permissions/has-permission? edit-permission)
    :edit-locked?               @(re-frame/subscribe [::edit-locked])
    :use-test-workflow?         @(re-frame/subscribe [::subs/use-test-workflow?])
    :customization-permissions? (permissions/has-permission? "customization")
    :general-form-inner-tabs (if snapshot?
                               {}
                               {:new #{:attachments :similar-items}
                                :edit #{:attachments :comments :similar-items}})
    :default-active-sub-tab (if (or new? snapshot?) nil (if new? :similar-items :attachments))
    :expanded? @(re-frame/subscribe [::grid.subs/expanded? :test :test-form.test-steps])
    :custom-banner (when snapshot? snapshot-warning-banner)}]))
